import React from 'react';
import Section from '../components/ui/Section';

const Impressum = () => {
  return (
    <div className="pt-24 min-h-screen">
      <Section className="pb-12 md:pb-24">
        <h1 className="text-4xl md:text-6xl mb-12">Impressum</h1>
        
        <div className="max-w-3xl font-inter text-brand-text/80 space-y-8">
          <div>
            <h3 className="text-xl text-brand-text mb-4 font-medium">Angaben gemäß § 5 TMG</h3>
            <p className="leading-relaxed">
              51north Real Estate GmbH<br/>
              Arnsdorf 26<br/>
              02894 Vierkirchen
            </p>
          </div>

          <div>
            <h3 className="text-xl text-brand-text mb-4 font-medium">Vertreten durch</h3>
            <p className="leading-relaxed">
              Ronny Müller<br/>
              Sebastian Janus<br/>
              Sebastian Heidrich
            </p>
          </div>

          <div>
            <h3 className="text-xl text-brand-text mb-4 font-medium">Kontakt</h3>
            <p className="leading-relaxed">
              E-Mail: projekte@51north.io
            </p>
          </div>

          <div>
            <h3 className="text-xl text-brand-text mb-4 font-medium">Registereintrag</h3>
            <p className="leading-relaxed">
              Registergericht: Amtsgericht Dresden<br/>
              Registernummer: HRB 44828
            </p>
          </div>

          <div>
            <h3 className="text-xl text-brand-text mb-4 font-medium">Umsatzsteuer-ID</h3>
            <p className="leading-relaxed">
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br/>
              DE340468662
            </p>
          </div>

          <div className="pt-8 border-t border-brand-text/10">
            <h3 className="text-xl text-brand-text mb-4 font-medium">Haftungsausschluss</h3>
            <p className="leading-relaxed mb-4">
              <strong>Haftung für Inhalte</strong><br/>
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p className="leading-relaxed mb-4">
              <strong>Haftung für Links</strong><br/>
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
            </p>
            <p className="leading-relaxed">
              <strong>Urheberrecht</strong><br/>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </div>
        </div>
      </Section>
    </div>
  );
};

export default Impressum;